import { GuestPassengersTable } from "@/components/organisms/MyFavourites/GuestPassengersTable";

export const FavouriteGuests = () => {
  return <GuestPassengersTable />;
};
